import {useState} from "react";

import {MultiLeadRecommendationType} from "../types/MultiLeadRecommendationType";

export interface IPriceFilter {
    lower?: number;
    upper?: number;
}

interface IOptions {
    recommendationType: MultiLeadRecommendationType;
    defaultPriceLimit: IPriceFilter;
}
export const useRecommendationsFilters = (options: IOptions) => {
    const [priceFilter, setPriceFilter] = useState<IPriceFilter>(options.defaultPriceLimit);

    return {priceFilter, setPriceFilter};
};
import {useState} from "react";

import {MultiLeadRecommendationType} from "../types/MultiLeadRecommendationType";

export interface IPriceFilter {
    lower?: number;
    upper?: number;
}

interface IOptions {
    recommendationType: MultiLeadRecommendationType;
    defaultPriceLimit: IPriceFilter;
}
export const useRecommendationsFilters = (options: IOptions) => {
    const [priceFilter, setPriceFilter] = useState<IPriceFilter>(options.defaultPriceLimit);

    return {priceFilter, setPriceFilter};
};
